<div class="carousel-container" [style.background-color]="backgroundColor">
  <button
    class="pl-2 arrow"
    mat-icon-button
    aria-label="Slide precedente"
    [disabled]="currentSlide === 0"
    (click)="prev()"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>

  <div class="carousel-items">
    @for (item of visibleItems; track item) {
      <ng-container
        *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
      ></ng-container>
    }
    @if (extraTemplate) {
      <ng-container
        *ngTemplateOutlet="extraTemplate; context: {}"
      ></ng-container>
    }
  </div>
  @if (remainingItemsCount > 0) {
    <span class="pl-4"> +{{ remainingItemsCount }} </span>
  }
  <button
    class="arrow pr-2"
    mat-icon-button
    aria-label="Slide successiva"
    [disabled]="currentSlide >= totalSlides - 1"
    (click)="next()"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
